import React from 'react';
import { Typography, Paper, Box, Card, CardContent, CardActionArea, Grid } from '@mui/material';
import { Link } from 'react-router-dom';

const ArticlesHub = () => {
  const articles = [
    {
      title: 'RIF History',
      description: 'The implementation of RIFs across various presidential administrations',
      path: '/articles/rif-history',
      color: '#3f51b5' // indigo
    },
    {
      title: 'Severance Explained',
      description: 'A detailed guide on federal severance pay calculations and eligibility',
      path: '/articles/severance-explained',
      color: '#f44336' // red
    },
    {
      title: 'RIF Survival Guide',
      description: 'Practical advice for federal employees facing a RIF',
      path: '/articles/rif-survival-guide',
      color: '#4caf50' // green
    }
  ];

  return (
    <Paper sx={{ p: 3, mt: 3, mb: 3, maxWidth: '100%', bgcolor: 'rgba(0,0,0,0.7)' }}>
      <Typography variant="h4" gutterBottom align="left">
        RIF & Severance Articles
      </Typography>
      
      <Typography variant="subtitle1" paragraph align="left">
        Browse our collection of informative articles about federal Reduction in Force procedures and severance pay.
      </Typography>
      
      <Grid container spacing={3} sx={{ mt: 2 }}>
        {articles.map((article, index) => (
          <Grid item xs={12} md={4} key={index}>
            <Card 
              sx={{ 
                height: '100%', 
                display: 'flex', 
                flexDirection: 'column',
                bgcolor: 'rgba(20,20,20,0.8)',
                color: 'white',
                borderTop: `4px solid ${article.color}`
              }}
            >
              <CardActionArea 
                component={Link} 
                to={article.path}
                sx={{ height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}
              >
                <CardContent>
                  <Typography variant="h5" component="h2" gutterBottom align="left">
                    {article.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" paragraph align="left" sx={{ color: 'rgba(255,255,255,0.7)' }}>
                    {article.description}
                  </Typography>
                  <Typography variant="button" display="block" align="left" sx={{ mt: 2, color: article.color }}>
                    Read Article
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
      
      <Box sx={{ mt: 4, p: 2, borderLeft: '4px solid #ffc107', bgcolor: 'rgba(50,50,50,0.5)' }}>
        <Typography variant="body2" align="left" sx={{ fontStyle: 'italic' }}>
          Our articles are regularly updated to reflect the latest guidance from OPM and other federal authorities.
          Last updated: {new Date().toLocaleDateString()}
        </Typography>
      </Box>
    </Paper>
  );
};

export default ArticlesHub; 